import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_CHANGED_EVENT } from "../../../../services/AuthService";
import PushNotificationService from "../_stubs/PushNotificationService";

/** Register iOS push tokens and handle notification taps inside the sliding shell. */
export function useSlidingPushNotifications() {
    const navigate = useNavigate();

    useEffect(() => {
        if (!PushNotificationService.isPushSupported()) {
            return undefined;
        }

        PushNotificationService.setPushNavigateHandler((path) => {
            if (typeof path === "string" && path.startsWith("/")) {
                navigate(path);
            }
        });

        void PushNotificationService.syncPushNotificationsIfNeeded();

        const onAuth = () => {
            void PushNotificationService.syncPushNotificationsIfNeeded();
        };
        window.addEventListener(AUTH_CHANGED_EVENT, onAuth);
        return () => {
            window.removeEventListener(AUTH_CHANGED_EVENT, onAuth);
        };
    }, [navigate]);
}
